export default {"src":"/customer-services/_next/static/media/logo-buyagain.c80e3421.svg","height":24,"width":160,"blurWidth":0,"blurHeight":0};